export const BASE_URL = 'https://app.linkmedicine.com/';
// export const BASE_URL = 'http://localhost:8080/';
export const IMGAE_REQUEST_PREFIX = BASE_URL + 'common/download?name=';
